import React, { useEffect, useState, useMemo, Suspense } from 'react';
import { connect } from 'react-redux';
import { Row, Card, CardBody, Button } from 'reactstrap';
import { Colxx, Separator } from 'components/common/CustomBootstrap';
import IntlMessages from 'helpers/IntlMessages';
import MasterTable from 'components/common/MasterTable';
import {
  getInActiveUser,
  manageActiveUser,
} from 'redux/admin/useractivation/action';
import { Link } from 'react-router-dom';
import NotificationModal from 'components/notifcationmodal/NotificationModal';
import moment from 'moment';
import { getUserRole } from 'utils/UserDetails';
import { getLocalTime } from 'constants/defaultValues';

const UserList = ({
  inactive_user,
  inactiveUserNotification,
  getInActiveUser,
  manageActiveUser,
}) => {
  const modalData = {
    isSuccess: 0,
    header: <IntlMessages id='wait-list.list-activation' />,
  };

  const [inActiveUser, setInActiveUser] = useState([]);
  const [show, setShow] = useState(false);
  const [notificationData, setNotificationData] = useState(modalData);

  useEffect(() => {
    let params = { status: 1 };
    if (getUserRole() === 'DISTRIBUTOR' || getUserRole() === 'RESELLER' || getUserRole() === 'SALES_MANAGER' || getUserRole() === 'AREA_SALES_MANAGER') {
      params.isChildren = 1;
    }
    getInActiveUser(params);
  }, []);

  useEffect(() => {
    setInActiveUser(inactive_user);
  }, [inactive_user]);

  useEffect(() => {
    if (inactiveUserNotification?.message) {
      let notifyData = {
        header: inactiveUserNotification.message,
        isSuccess: inactiveUserNotification.isSuccess,
      };

      setNotificationData({ ...notificationData, ...notifyData });
    }
  }, [inactiveUserNotification]);

  const cols = React.useMemo(
    () => [
      {
        Header: <IntlMessages id="userlist.customer-no" />,
        accessor: 'relationship_no',
        cellClass: 'text-left',
        Cell: (props) => <>{props.value}</>,
        sortType: 'basic',
      },
      {
        Header: <IntlMessages id="userlist.username" />,
        accessor: 'username',
        cellClass: 'text-left',
        Cell: (props) => <>{props.value}</>,
        sortType: 'basic',
      },
      {
        Header: <IntlMessages id="userlist.customer-name" />,
        accessor: 'customername',
        cellClass: 'text-left',
        Cell: (props) => (
          <>
            {props.row.original.firstname + ' ' + props.row.original.lastname}
          </>
        ),
        sortType: 'basic',
      },
      {
        Header: <IntlMessages id="userlist.reference-id" />,
        accessor: 'refeence_id',
        Cell: (props) => <>{props.value}</>,
        sortType: 'basic',
      },
      {
        Header: <IntlMessages id="userlist.request-date" />,
        accessor: 'created_date',
        Cell: (props) => <>{getLocalTime(props.value)}</>,
        sortType: 'basic',
      },

      {
        Header: <IntlMessages id="userlist.action" />,
        accessor: 'action',
        Cell: (props) => {
          return (
            <div className="d-flex align-items-center justify-content-center">
              <Link
                to="#"
                className="url-link"
                onClick={(e) => {
                  e.preventDefault();
                  activeUser(props);
                }}
              >
                <IntlMessages id="userlist.activate" />
              </Link>
            </div>
          );
        },
        sortType: 'basic',
      },
    ],
    []
  );

  const activeUser = (data) => {
    let params = data?.row?.original;
    manageActiveUser({ userMacID: params.user_mac_id, userID: params.userid });
  };
  const toggleModal = () => {
    setShow(!show);
  };

  return (
    <div className="bus-salesreport">
      <Row>
        <Colxx sm="12" className="order-1">
          <h1 className="page-heading">
            <IntlMessages id="wait-list.title"></IntlMessages>
          </h1>
        </Colxx>
      </Row>
      <Row>
        <Colxx xxs="12">
          <Separator className="mb-5 separator-line-color" />
        </Colxx>
      </Row>
      <Row className="mb-4">
        <Colxx xxs="12">
          <Card>
            <CardBody>
              <MasterTable
                columns={cols}
                data={inActiveUser.length ? inActiveUser : []}
              />
            </CardBody>
          </Card>
        </Colxx>
      </Row>

      <Suspense>
        <NotificationModal
          modalOpen={show}
          toggleModal={toggleModal}
          modalData={notificationData}
        />
      </Suspense>
    </div>
  );
};

const mapStateToProps = (state) => ({
  inactive_user: state.userActivatedList.inactive_user,
  inactiveUserNotification: state.common.common_notification,
});

export default connect(mapStateToProps, { getInActiveUser, manageActiveUser })(
  UserList
);
